import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { TariffService } from 'src/app/services/tariff/tariff.service';

@Component({
  selector: 'app-tariff',
  templateUrl: './tariff.component.html',
  styleUrls: ['./tariff.component.scss']
})
export class TariffComponent implements OnInit {

  loadingSpinner = false;
  currentEnterpriseCurrency: string;
  tariffForm: UntypedFormGroup;
  ref = new UntypedFormControl('', [Validators.required]);
  cpoTariffCoef = new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(1)]);
  operatingFees = new UntypedFormControl('', [Validators.required]);
  intermediationFees = new UntypedFormControl('', [Validators.required]);
  lang = new UntypedFormControl('fr', [Validators.required]);
  textFr = new UntypedFormControl('', [Validators.required]);
  textEn = new UntypedFormControl('', [Validators.required]);
  textEs = new UntypedFormControl('', [Validators.required]);
  textAl = new UntypedFormControl('', [Validators.required]);
  isSubmitted = false;
  enterprise;
  hasTariff = false;
  tariff;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private constantService: ConstantService,
    private tariffService: TariffService,
    private localStorage: CustomStorageService,
  ) { }

  ngOnInit(): void {
    this.getTariff();
    this.initializeTariffForm(this.ref, this.cpoTariffCoef, this.operatingFees,
      this.intermediationFees, this.textFr, this.textEn, this.textEs, this.textAl);
  }

  /**
   * get tariff
   */
  getTariff(): void {
    this.loadingSpinner = true;
    this.enterprise = this.localStorage.getEnterprise();
    // this.currentEnterpriseCurrency = this.constantService.getCurrencySymbol(this.enterprise.currency) ;
    this.currentEnterpriseCurrency = '€';
    this.tariffService.getTariff(this.enterprise.id).subscribe(
      (res) => {

        this.loadingSpinner = false;
        this.hasTariff = true;
        this.tariff = res['tariff'];
        this.toFixedTariff();
        this.initializeTariffForm(this.tariff.ref, this.tariff.cpoTariffCoef, this.tariff.operatingFees,
          this.tariff.intermediationFees, this.tariff.description[0].text, this.tariff.description[1].text,
          this.tariff.description[2].text, this.tariff.description[3].text);
      }, (error) => {
        this.loadingSpinner = false;
        this.hasTariff = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
        }
      });
  }

  /**
   * initialize Tarif fForm
   */
  initializeTariffForm(ref, cpoTariffCoef, operatingFees, intermediationFees, textFr, textEn, textEs, textAl): void {
    this.tariffForm = this.formBuilder.group({
      ref,
      cpoTariffCoef,
      operatingFees,
      intermediationFees,
      textFr,
      textEn,
      textEs,
      textAl,
    });
  }

  addOrUpdateTariff() {
    this.tariffForm.disable();
    if (this.tariffForm.controls.cpoTariffCoef.value <0 || this.tariffForm.controls.cpoTariffCoef.value >1) {
      this.constantService.showErrorToast('tariff.general.cpoTariffCoef');
      return;
    }
    this.loadingSpinner = true;
    const description = [];
    description.push(
      {
        lang: 'fr',
        text: this.tariffForm.value.textFr
      },
      {
        lang: 'en',
        text: this.tariffForm.value.textEn
      },
      {
        lang: 'es',
        text: this.tariffForm.value.textEs
      },
      {
        lang: 'de',
        text: this.tariffForm.value.textAl
      }
    );
    const body = {
      ref: this.tariffForm.value.ref,
      cpoTariffCoef: this.tariffForm.value.cpoTariffCoef,
      intermediationFees: this.tariffForm.value.intermediationFees,
      operatingFees: this.tariffForm.value.operatingFees,
      description
    };
    this.hasTariff ? this.updateTariff(body) : this.addNewTariff(body);
  }

  /**
   * add a new tariff
   */
  addNewTariff(body): void {
    this.tariffService.addTariffFees(body).subscribe(
      (res) => {
        this.tariff = res['eMSPTarif'];
        this.toFixedTariff();
        this.loadingSpinner = false;
        this.tariffForm.enable();
        this.hasTariff = true;
      }, (error) => {
        this.loadingSpinner = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
        }
      }
    );
  }

  /**
   * Update fees tariff
   */
  updateTariff(body): void {
  this.tariffService.editTariffFees(this.tariff._id, body).subscribe(
    (res: any) => {
      this.loadingSpinner = false;
      this.tariff = res['updatedTariff'];
      this.toFixedTariff();
      this.tariffForm.enable();
    }, (error) => {
      switch (error.status) {
        case 401:
          this.authService.logout();
          break;
      }
    }
  );
  }

  toFixedTariff() {
    this.tariff.cpoTariffCoef = this.tariff.cpoTariffCoef.toFixed(2);
    this.tariff.operatingFees = this.tariff.operatingFees.toFixed(2);
    this.tariff.intermediationFees = this.tariff.intermediationFees.toFixed(2);
  }
}
